import { Calendar } from "@/ui/components/form/Calendar/Calendar";
import {
  CALENDAR_PREVIEW_CLASS_MAP,
  type TCalendarPreviewPanelProps,
} from "@/ui/components/form/Calendar/CalendarPreview.config";
import { Flex } from "@/ui/components/layout/Flex";
import { cn } from "@/ui/lib/utils";

export const CalendarPreviewPanel = ({
  calendar,
  id,
  isOpen,
}: TCalendarPreviewPanelProps) => (
  <div
    id={id}
    aria-hidden={!isOpen}
    data-component="CalendarPreviewPanel"
    inert={!isOpen}
    className={cn(
      CALENDAR_PREVIEW_CLASS_MAP.panel,
      isOpen
        ? CALENDAR_PREVIEW_CLASS_MAP.panelOpen
        : CALENDAR_PREVIEW_CLASS_MAP.panelClosed,
    )}
  >
    <div
      className={cn(
        CALENDAR_PREVIEW_CLASS_MAP.content,
        isOpen
          ? CALENDAR_PREVIEW_CLASS_MAP.contentOpen
          : CALENDAR_PREVIEW_CLASS_MAP.contentClosed,
      )}
    >
      <Flex
        justify="center"
        className={CALENDAR_PREVIEW_CLASS_MAP.calendar}
      >
        <Calendar mode="single" {...calendar} />
      </Flex>
    </div>
  </div>
);

CalendarPreviewPanel.displayName = "CalendarPreviewPanel";
